var map = {
	"./404.svg": 73927,
	"./assistance.svg": 69165,
	"./chinese.svg": 72270,
	"./code.svg": 79570,
	"./collection.svg": 2341,
	"./home.svg": 98716,
	"./project.svg": 74212,
	"./push.svg": 28097,
	"./questionBank.svg": 24691,
	"./questionOutline.svg": 86693,
	"./questionType.svg": 24569,
	"./recycle.svg": 63040,
	"./report.svg": 25987,
	"./setting.svg": 22647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;